/** Header X-Customer-Session para endpoints públicos de cliente. */

import { getCustomerSessionToken } from '@/lib/localCustomer';

export function customerSessionHeaders(businessId) {
  const token = getCustomerSessionToken(businessId);
  return token ? { 'X-Customer-Session': token } : {};
}

export function withCustomerSession(config = {}, businessId) {
  const headers = { ...(config.headers || {}), ...customerSessionHeaders(businessId) };
  return { ...config, headers };
}
